
import React, {  useEffect, useRef, useState } from 'react';
import { DatePickerABX } from './DatePicker';
import { formatDate } from '../../../utils/utils';
import { Tooltip } from '../utils/Tooltip';

export const MultiSelectorFecha =  ({startDate,
    setStartDate,
    endDate,
    setEndDate,
    classNameInput,
    readOnly = false,
    identificador = 'default',
    minDate,
    maxDate
}) => {
    const [ mostrar, setMostrar ] = useState(false);
    const contenedorFechaRef = useRef(null);
    const iconoMostrarRef = useRef(null);
    const [opcionSeleccionada, setOpcionSeleccionada ] = useState(2)
    useEffect(() => {
        //Se oculte automaticamente cuando no este el focus dentro del contenedor de select
        document.addEventListener('mousedown',(event) =>{
            if(
                mostrar && contenedorFechaRef.current &&
                !contenedorFechaRef.current.contains(event.target) && 
                !iconoMostrarRef.current.contains(event.target)
            ){
                setMostrar(false)
            }
        })
    },[mostrar])

    useEffect(() => {
        if(opcionSeleccionada === 1)
        {
            setStartDate(formatDate(new Date()))
            setEndDate(formatDate(new Date()))
        }
        if(opcionSeleccionada === 3)
        {
            setStartDate(formatDate(new Date(2023, 0, 1)))
            setEndDate(formatDate(new Date()))
        }
    },[opcionSeleccionada])

    const mostrarOcultarOpciones = () => {
        setMostrar(prevMostrar => !prevMostrar)
    }

    return(
        <section>
            <section
                className={`border min-w-[240px] lg:min-w-[200px] ${mostrar ? 'border-blue-500' : 'border-zinc-400' } cursor-pointer
                w-full  lg:w-auto lg:text-sm py-1 px-[5px] rounded grid grid-cols-[minmax(0,075fr)_minmax(0,850fr)_minmax(0,075fr)] items-center `}
                ref={iconoMostrarRef}
                onClick={mostrarOcultarOpciones}
            >
                <i className={`fa fa-calendar-days text-center ${mostrar ? ' text-blue-500 ' : ''}`} data-tip={'iconDate'} data-for={'iconDate'}></i>
                <Tooltip id={'iconDate'}>Selector de fecha</Tooltip>
                <span className='px-[3px] text-sm text-center'>{ opcionSeleccionada !== 3 && (startDate)}
                    { opcionSeleccionada === 2  ? ' - ' + (endDate) : opcionSeleccionada === 3 ?  ' Todos ' : ''}
                </span>
                <i
                    className={`fa ${mostrar ? 'fa-chevron-up' : 'fa-chevron-down'} text-center`}
                ></i>
            </section>

            <div
                key={'Contenedor_Fechas'}
                ref={contenedorFechaRef}
                style={{zIndex: 90}}
                className={`${!mostrar ? ' max-h-0 h-0 opacity-0 invisible pointer-events-none ' : '  h-10 max-h-5 visble '}
                w-[400px] lg:w-[320px] min-h-[120px] transition-all duration-500 ease-out rounded flex flex-col gap-2 bg-zinc-900 border-gray-600 border absolute p-2`}
            >
                <div className='grid grid-cols-[minmax(0,45fr)_minmax(0,55fr)] content-radio flex-grow items-center'>
                    <input
                        type='radio'
                        id={'oneDate' + identificador}
                        name={'rbDate' + identificador}
                        onChange={()=>setOpcionSeleccionada(1)}
                        checked={opcionSeleccionada === 1 ? true : false}
                    />
                    <label htmlFor={'oneDate' + identificador}>Fecha</label>
                    <div className=''>
                        {
                            opcionSeleccionada === 1 ?
                                <DatePickerABX
                                    setDate={setStartDate}
                                    date={startDate}
                                    setEndDate={setEndDate}
                                    endDate={endDate}
                                    dobleFecha={true}
                                    ocultarIcono={true}
                                    minDate={minDate}
                                    classNameInput={' text-[#048cc6] bg-zinc-800'}
                                />
                                : ''
                        }
                    </div>
                    <input
                        type='radio'
                        id={'twoDate' + identificador}
                        name={'rbDate'+identificador}
                        onChange={()=>setOpcionSeleccionada(2)}
                        checked={opcionSeleccionada === 2 ? true : false}
                    />
                    <label className=' whitespace-nowrap w-[40%]x' htmlFor={'twoDate' + identificador}>Rango</label>
                    {
                        opcionSeleccionada === 2 ?
                            <div className='flex gap-2'>
                                <DatePickerABX
                                    setDate={setStartDate}
                                    date={startDate}
                                    maxDate={endDate}
                                    ocultarIcono={true}
                                    minDate={minDate}
                                    classNameInput={' text-[#048cc6] bg-zinc-800'}
                                />
                                <DatePickerABX
                                    setDate={setEndDate}
                                    date={endDate}
                                    minDate={startDate}
                                    maxDate={new Date()}
                                    ocultarIcono={true}
                                    classNameInput={' text-[#048cc6] bg-zinc-800'}
                                />
                            </div>
                        : <span></span>
                    }
                    <input
                        type='radio'
                        id={'allDate' + identificador}
                        name={'rbDate'+identificador}
                        onChange={()=>setOpcionSeleccionada(3)}
                        checked={opcionSeleccionada === 3 ? true : false}
                    />
                    <label htmlFor={'allDate' + identificador}>Todos</label>
                </div>
            </div>
        </section>
    )
}